import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Met à jour l'état pour que le prochain rendu affiche l'UI de fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log l'erreur pour le débogage
    console.error("ErrorBoundary a capturé une erreur:", error, errorInfo);

    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // UI de fallback personnalisée
      return (
        <div
          style={{
            padding: "20px",
            margin: "20px",
            border: "1px solid #e53e3e",
            borderRadius: "8px",
            backgroundColor: "#fed7d7",
            color: "#742a2a",
          }}
        >
          <h2 style={{ margin: "0 0 16px 0", color: "#742a2a" }}>
            🚨 Une erreur est survenue
          </h2>
          <p style={{ margin: "0 0 16px 0" }}>
            L'application a rencontré un problème inattendu. Veuillez rafraîchir
            la page ou contacter le support si le problème persiste.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 16px",
              backgroundColor: "#742a2a",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            🔄 Rafraîchir la page
          </button>
          {process.env.NODE_ENV === "development" && this.state.error && (
            <details style={{ marginTop: "16px" }}>
              <summary style={{ cursor: "pointer", fontWeight: "bold" }}>
                Détails techniques (développement)
              </summary>
              <pre
                style={{
                  backgroundColor: "#f7fafc",
                  padding: "12px",
                  borderRadius: "4px",
                  overflow: "auto",
                  fontSize: "12px",
                }}
              >
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
